<template>
  <div class="ai-write-container">
    <div class="ai-write-content">
      <div v-if="aIType == 1">
        <h1 class="ai-write-title">AI智能写作</h1>
        <p class="ai-write-subtitle">
          四步赋能，开启智能写作便捷之旅！<br />让AI写作触手可及！
        </p>
        <div
          class="ai-output-container"
          style="padding: 10px"
          :style="{ backgroundImage: `url(${this.$imagePath.image33})` }"
        >
          <div class="ai-output" style="text-align: left">
            <div>
              <van-field
                style="height: 160px"
                type="textarea"
                v-model="form.title"
                placeholder="请输入文章标题"
                :autosize="true"
              />
            </div>
          </div>
          <div style="text-align: right">
            <el-button
              type="primary"
              class="ai-write-button right"
              @click="handleQuery"
              :loading="loading"
            >
              {{ loading ? "生成中..." : "立即生成" }}
            </el-button>
          </div>
        </div>
        <div class="ai-write-features" style="margin-top: 50px">
          <div class="feature-item">
            <div class="feature-icon">
              <img :src="this.$imagePath.image_icon_1_33" alt="" />
            </div>
            <span class="feature-text">一键成文</span>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <img :src="this.$imagePath.image_icon_2_33" alt="" />
            </div>
            <span class="feature-text">快速发布</span>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <img :src="this.$imagePath.image_icon_3_33" alt="" />
            </div>
            <span class="feature-text">多领域覆盖</span>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <img :src="this.$imagePath.image_icon_3_33" alt="" />
            </div>
            <span class="feature-text">高效产出</span>
          </div>
        </div>
      </div>
      <div v-if="aIType == 2">
        <div style="border: 2px solid pink" class="ai-write-features-input">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
              width: 100%;
              padding-right: 10px;
            "
          >
            <div>
              <van-field
                v-model="form.title"
                placeholder="请输入文章标题"
                type="text"
              />
            </div>
            <el-button
              type="primary"
              class="ai-write-button right"
              :loading="loading"
              icon="el-icon-magic-stick"
            >
              {{ loading ? "生成中..." : "立即生成" }}
            </el-button>
          </div>
        </div>
        <div class="ai-output-container-success" style="">
          <div
            class="ai-output"
            style="
              text-align: left;
              border: 1px solid #0f6aef;
              border-radius: 20px;
              overflow: auto;
              height: 280px;
              background-color: #fff;
            "
          >
            <van-field v-model="currentReply" autosize type="textarea" />
            <!-- <el-input
            type="textarea"
            autosize
            placeholder="请输入内容"
            v-model="form.title"
            size="medium"
          >
          </el-input> -->
          </div>
        </div>
        <div style="text-align: right; text-align: center; padding: 20px">
          <el-button
            type="primary"
            class="ai-write-button left"
            :loading="loading"
            icon="el-icon-refresh"
          >
            换个大纲
          </el-button>
          <el-button
            type="primary"
            class="ai-write-button right"
            :loading="loading"
            icon="el-icon-magic-stick"
          >
            立即排版
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AiNavbar",
  data() {
    return {
      AIresult: [],
      currentReply: "", // 流式实时输出内容
      currentQuestion: "",
      form: {
        title: "",
      },
      loading: false,
      aIType: 1,
    };
  },
  methods: {
    async handleQuery() {
      console.log("立即生成了", this.aIType);
      if (!this.form.title.trim()) {
        this.$message.warning("请输入文章标题");
        return;
      }

      // 初始化状态
      this.loading = true;
      this.currentQuestion = this.form.title;
      this.currentReply = ""; // 清空上次结果
      this.aIType = 2;
      try {
        // 发送流式请求
        const response = await fetch(
          "http://192.168.3.194:5050/api/v1/AI/qwen/chat/stream",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              message: this.form.title,
              temperature: 0.7,
              max_tokens: 1500,
            }),
          },
        );

        // ------------ 核心：流式读取 ------------
        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          // 解码数据
          const chunk = decoder.decode(value, { stream: true });
          const lines = chunk.split("\n");

          for (const line of lines) {
            if (!line.trim()) continue;

            // SSE 格式：data: {...}
            if (line.startsWith("data: ")) {
              const dataStr = line.replace("data: ", "").trim();

              // 结束标记
              if (dataStr === "[DONE]") continue;

              try {
                const data = JSON.parse(dataStr);

                // 实时追加文字（打字机效果）
                if (data.content) {
                  // ==========================================
                  // ✅ 正确位置：在这里加延迟！
                  // ==========================================
                  for (let c of data.content) {
                    this.currentReply += c;
                    await new Promise((r) => setTimeout(r, 60));
                  }
                }

                // 真正结束
                if (data.done) {
                  break;
                }
              } catch (e) {}
            }
          }
        }
        // 流结束，存入历史记录
        this.AIresult.push({
          question: this.currentQuestion,
          reply: this.currentReply,
        });
        this.loading = false;
      } catch (err) {
        this.$message.error("生成失败：" + err.message);
      } finally {
        this.loading = false;
        this.form.title = ""; // 清空输入框
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep.ai-write-features-input {
  display: flex;
  .van-cell {
    background-color: transparent;
  }
}
.ai-write-features-input {
  width: 100%;
  height: 65px;
  border-radius: 29px;
  opacity: 1;
  margin-bottom: 15px;
  background: rgba(253, 253, 255, 0.6);
  box-sizing: border-box;
  border: 2px solid #c4d9ff;
  backdrop-filter: blur(10px);
}
.ai-output-container-success {
  border: 1px solid #a5c4fd;
  border-radius: 21px;
  height: 300px;
  padding: 10px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  background-color: #fdfdff;
}
.ai-output-container {
  background-size: 100% 100%;
  .ai-output {
    height: 180px;
    padding: 10px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
}

.ai-write-container {
  min-height: 100vh;
  padding-top: 50px;
  //display: flex;
  // justify-content: center;
  // align-items: center;
  // padding: 20px;
}

.ai-write-content {
  max-width: 600px;
  width: 100%;
  text-align: center;
}

.ai-write-title {
  font-size: 36px;
  font-weight: bold;
  color: #323232;
  margin-bottom: 20px;
  background: linear-gradient(100deg, #086fef 0%, #a208ef 84%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.ai-write-subtitle {
  font-size: 16px;
  color: #666;
  margin-bottom: 40px;
  line-height: 1.5;
}

.ai-write-input-container {
  position: relative;
  margin-bottom: 60px;
}

.ai-write-input {
  height: 60px;
  border-radius: 30px;
  border: 2px solid #e0e7ff;
  padding: 0 20px;
  font-size: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.ai-write-input:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
}
.ai-write-button {
  border-radius: 25px;
  border: none;
  padding: 10px 15px;
  box-shadow: 0 4px 6px rgba(79, 70, 229, 0.3);
  transition: all 0.3s ease;
}
.ai-write-button.left {
  color: #323232;
  background-color: #fff !important;
}
.ai-write-button.right {
  background: linear-gradient(100deg, #086fef 0%, #a208ef 84%);
}

.ai-write-button:hover {
  transform: translateY(-2%) scale(1.05);
  box-shadow: 0 6px 8px rgba(79, 70, 229, 0.4);
}

.ai-write-features {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 20px;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.feature-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 24px;
  color: #8b5cf6;
}

.feature-text {
  font-size: 13px;
  color: #666;
}

@media (max-width: 768px) {
  .ai-write-title {
    font-size: 28px;
  }

  .ai-write-subtitle {
    font-size: 14px;
  }

  .ai-write-input {
    height: 50px;
  }

  .ai-write-button {
    height: 40px;
    font-size: 14px;
    padding: 0 20px;
  }

  .feature-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .feature-text {
    font-size: 12px;
  }
}
</style>
